import api from './api';

class SettingPosService {
  getSettings(branchId) {
    return api.get('/merchant/pos-settings', { params: { branch_id: branchId } });
  }

  updateSettings(dataForm) {
    return api.post('/merchant/pos-settings', dataForm);
  }

  importSettingsJsonPreview(dataForm) {
    return api.post('/merchant/pos-settings/import-json/preview', dataForm, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  importSettingsJson(dataForm) {
    return api.post('/merchant/pos-settings/import-json', dataForm, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  copyToBranches(dataForm) {
    return api.post('/merchant/pos-settings/copy', dataForm);
  }

  getPaymentMethods(branchId) {
    return api.get('/merchant/pos-settings/payment-methods', { params: { branch_id: branchId } });
  }

  savePaymentMethods(dataForm) {
    return api.post('/merchant/pos-settings/payment-methods', dataForm);
  }

  getPromotions(branchId) {
    return api.get('/merchant/pos-settings/promotions', { params: { branch_id: branchId } });
  }

  savePromotions(dataForm) {
    return api.post('/merchant/pos-settings/promotions', dataForm);
  }
}

export default new SettingPosService();
